$(".go-top").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

window.addEventListener('DOMContentLoaded', () => {
    // Show all products button for the featured collection alt section
    const showAllProductsBtn = document.querySelectorAll('.js-show-all-products');
    if(showAllProductsBtn.length) {
        showAllProductsBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const grid = btn.closest('.featured-collection').querySelector('.js-show-all-products-grid');
                grid.classList.remove('hide');
                btn.classList.add('hide');
            })
        })
    }
    
    // FAQ
    const faqNav = document.querySelectorAll('.tab-nav button');

    for (var x = 0; x < faqNav.length; x++) {

        faqNav[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;
            var banner = e.target.dataset.banner;

            // inactive all button
            for (var i = 0; i < faqNav.length; i++) {
                faqNav[i].closest('li').classList.remove('active')
            }

            // active selected
            e.target.closest('li').classList.add('active');

            // inactive all title
            // for (var i = 0; i < document.querySelectorAll('.grid-title h2').length; i++) {
            //     document.querySelectorAll('.grid-title h2')[i].classList.remove('active')
            // }

            // active selected title
            // document.querySelector('.grid-title h2[data-parent="' + parent + '"]').classList.add('active');

            
            // close all
            for (var i = 0; i < document.querySelectorAll('.tab-content').length; i++) {
                document.querySelectorAll('.tab-content')[i].classList.remove('open')
            }
            
            document.getElementById("tab-content_image").src = banner;

            // open selected
            for (var i = 0; i < document.querySelectorAll('.tab-content[data-parent="' + parent + '"]').length; i++) {
                document.querySelectorAll('.tab-content[data-parent="' + parent + '"]')[i].classList.add('open')
            }
        });
    }


    if (faqNav[0]) {
        faqNav[0].click();
    }

    const faqQA = document.querySelectorAll('.grid-tab_item button');

    for (var x = 0; x < faqQA.length; x++) {
        faqQA[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;

            // inactive all button
            // for (var i = 0; i < faqQA.length; i++) {
            //     faqQA[i].closest('.grid-tab_item').classList.remove('active')
            // }

            // active selected
            e.target.closest('.grid-tab_item').classList.toggle('active');
        });
    }

    // Read more - show more content
    const readMoreBtn = document.querySelectorAll('.js-read-more');
    if(readMoreBtn.length) {
        readMoreBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const self = e.target;
                const parent = self.closest('.read-more-wrapper');
                const lessContent = parent.querySelector('.read-more__initial-content');
                const moreContent = parent.querySelector('.read-more__more-content');
                const btnText = self.textContent;
                lessContent.classList.toggle('hide');
                moreContent.classList.toggle('hide');
                if(btnText === 'Read more') {
                    self.textContent = 'Read less';
                } else {
                    self.textContent = 'Read more';
                }
            })
        });
    }

    // Tabbed content
    const tabBtns = document.querySelectorAll('.tabbed-content__button');
    if(tabBtns.length) {
        tabBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const self = e.target;
                const parent = self.closest('.tabbed-content__section');
                const tabTarget = self.getAttribute('data-target');
                const tabTargetContent = parent.querySelector(`#${tabTarget}`);
                const currentActiveTab = parent.querySelector('.tabbed-content__content.active');
                const currentActiveBtn = parent.querySelector('.tabbed-content__button.active');

                currentActiveTab.classList.remove('active');
                currentActiveBtn.classList.remove('active');
                self.classList.add('active');
                tabTargetContent.classList.add('active');

            })
        })
    }

     // Blog and PLP load more
     function blogPLPLoadMore() {
        const loadMoreBtn = document.querySelector('.js-load-more');
        if(loadMoreBtn) {
            const totalPagesEl = document.querySelector('[data-total-pages]');
            const nextUrlEl = document.querySelector('[data-next-url]');
            const currentPageEl = document.querySelector('[data-current-page]');
            const nextPageEl = document.querySelector('[data-next-page]');
            let totalPages = +totalPagesEl.value;
            let nextUrl = nextUrlEl.value;
            let currentPage = +currentPageEl.value;
            let nextPage = +nextPageEl.value;

            jQuery('.js-load-more').on('click', function(){
                const $this = $(this);
                nextUrl = nextUrlEl.value;

                if (!totalPagesEl || !nextUrlEl || !currentPageEl || !nextPageEl) return;

                $this.attr('disabled', true);
                $this.find('[loader]').addClass('btn--loading');
                
                $.ajax({
                    url: nextUrl,
                    type: 'GET',
                    dataType: 'html',
                    success: function(responseHTML){
                        $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
                        $('[data-current-page]').val(nextPage);
                        nextPage++;
                        $('[data-next-page]').val(nextPage);
                        $('[data-next-url]').val($('[data-next-url]').val().replace(/page=[0-9]+/,'page='+nextPage));
                        window.history.pushState({"html":responseHTML.html,"pageTitle":responseHTML.pageTitle},"", nextUrl);
                        if (window.AOS) { AOS.refreshHard() }
                        var api = new Yotpo.API(yotpo);
                        api.refreshWidgets();
                        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                    },
                    error: function (jqXHR) {
                        console.log(jqXHR);
                    },
                    complete: function() {
                        currentPage++;
                        if(currentPage < totalPages) {
                            $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
                        }
                        if(currentPage >= totalPages) {
                            $this.addClass('hide');
                        } 
                    }
                })
            });
            if(currentPage >= totalPages) {
                loadMoreBtn.classList.add('hide');
            } 
        }
    }
    blogPLPLoadMore();

    // Blog and PLP load previous
    function blogPLPLoadPrev() {
        const loadPrevBtn = document.querySelector('.js-load-prev');
        if(loadPrevBtn) {
            const prevUrlEl = document.querySelector('[data-prev-url]');
            const prevPageEl = document.querySelector('[data-prev-page]');
            let prevUrl = prevUrlEl.value;
            let prevPage = +prevPageEl.value;

            jQuery('.js-load-prev').on('click', function(){
                const $this = $(this);
                prevUrl = prevUrlEl.value;
                if ( !prevUrlEl || !prevPageEl) return;

                $this.attr('disabled', true);
                $this.find('[loader]').addClass('btn--loading');
                
                $.ajax({
                    url: prevUrl,
                    type: 'GET',
                    dataType: 'html',
                    success: function(responseHTML){
                        $('.grid--view-items').prepend($(responseHTML).find('.grid--view-items').html());
                        prevPage--;
                        $('[data-prev-page]').val(prevPage);
                        $('[data-prev-url]').val($('[data-prev-url]').val().replace(/page=[0-9]+/,'page='+prevPage));
                        window.history.pushState({"html":responseHTML.html,"pageTitle":responseHTML.pageTitle},"", prevUrl);
                        if (window.AOS) { AOS.refreshHard() }
                        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                        var api = new Yotpo.API(yotpo);
                        api.refreshWidgets();
                    },
                    error: function (jqXHR) {
                        console.log(jqXHR);
                    },
                    complete: function() {
                        if(prevPage >= 1) {
                            $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
                            $this.removeClass('hide');
                        }
                        if(prevPage < 1) {
                            $this.addClass('hide');
                        } 
                    }
                })
            });
            if(prevPage < 1) {
                loadPrevBtn.classList.add('hide');
            } else {
                loadPrevBtn.classList.remove('hide');
            }
        }
    }
    blogPLPLoadPrev();

    document.addEventListener('collection:reloaded', function() {
        blogPLPLoadMore();
        blogPLPLoadPrev();
    })

    // Article show hidden content
    const articleReadMoreBtn = document.querySelector('.article-hidden-content__read-more');
    if(articleReadMoreBtn) {
        articleReadMoreBtn.addEventListener('click', (e) => {
            document.querySelector('.article-hidden-content').classList.remove('article-hidden-content');
            e.target.classList.add('hide');
        })
    }

    const debounce = (f, delay) => {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        }
    }
    
    
    const sliderReinitCallback = ([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
    }

    const activateSlider = (elem) => {
        const defaultSettings = {
            prevNextButtons: false,
            cellAlign: "left",
            groupCells: true
        }
        const { sliderSettings: customSettings } = elem.dataset;
        let flkty;
        if (customSettings)
            Object.assign(defaultSettings, JSON.parse(customSettings));

        flkty = new Flickity(elem, defaultSettings);

        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(elem);
    }

    const sliders = document.querySelectorAll('.slider-enabled');
    if(sliders.length) {
        sliders.forEach(slider => {
            activateSlider(slider);
        })
    }

    // Article "blog-posts.liquid" slider
    var blogSlider = document.querySelectorAll('.blog-layout_slider .articles');

    if ( blogSlider ) {
        for (var x = 0; x < blogSlider.length; x++ ) {
            var flkty = new Flickity( blogSlider[x], {
                // adaptiveHeight: true,
                lazyLoad: true,
                cellAlign: 'left',
                freeScroll: true,
                pageDots: false,
                // setGallerySize: false
            });
        }

        if (flkty) {
            const sliderGridItem = document.querySelectorAll('.blog-layout_slider .grid__item');
            if ( sliderGridItem ) {
                for (var x = 0; x < sliderGridItem.length; x++ ) {
                    sliderGridItem[x].classList.add('active');
                }
            }
        }
    }

    const addProductToCartById = (id, qty=1, props, cartDrawer) => {

        let formData = {
            'items': [{
                'id': id,
                'quantity': qty
            }]
        };
        if (props) {
            formData = {
                'items': [{
                    'id': id,
                    'quantity': qty,
                    'properties': props
                }]
            }
        }
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            document.dispatchEvent(new CustomEvent('cart:build'));

            if (cartDrawer == 'open') {
                var cart = new theme.CartDrawer
                cart.open();
            }

            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    document.addEventListener('cart:ready', () => {
        const cartUpsellSlider = document.querySelector('#cartUpsell');
        if(cartUpsellSlider) {
            activateSlider(cartUpsellSlider);
        }
    });

    const fetchCart = async () => {
        try {
          const res = await fetch('/cart.js');
          const data = await res.json();
          if (res.ok) return data;
        } catch (error) {
          console.log(error);
          return null
        }
    }

    const checkCartPromo = async() => {
        $('.drawer-promotion-button').hide();
        $('.promotion-tier').hide();
        
        const cartData = await fetchCart();
        const items = cartData.items;
        const cartSubtotal = cartData.items_subtotal_price
        let promoTiersInCart = []
        let has_available_gifts = false
        let cart_tier_promotion_tracker = [];

        items.forEach(item => {
            if(item.properties && item.properties['_promo-tier']) {
                promoTiersInCart.push(item.properties['_promo-tier']);
            }
        })

        for (let i=0;i<theme.gwp_tiers.length;i++) {
            cart_tier_promotion_tracker.push(false);
        }

        for (let i=0;i<theme.gwp_tiers.length;i++) {
            let tier_level = i+1;
            if ((cartSubtotal/100) >= theme.gwp_tiers[i].threshold && !cart_tier_promotion_tracker[i]) {
                if(!promoTiersInCart.includes(tier_level.toString())) {
                    has_available_gifts = true;
                    $('.promotion-tier--'+tier_level).show();
                }
            }
        }

        if (has_available_gifts) {
            $('.drawer-promotion-button').show();
        }
    }
    
    // Upsell quick add
    $(document).on('click', '.js-upsell-quick-add', (e) => {
        const button = e.target;
        button.classList.add('btn--loading');
        const variantId = button.getAttribute('data-variant-id');
        const isPromo = button.getAttribute('data-promo');
        const tier = button.getAttribute('data-tier');
        const qty = button.getAttribute('data-min') || 1;
        if(isPromo && tier) {
            const props = {
                '_promo-tier': tier
            }
            addProductToCartById(variantId,1,props);
            setTimeout(function() {
                theme.CartPromoDrawer.close();
            },500);
        } else {
            addProductToCartById(variantId, qty);
        }
    })
    
    // Upsell show variant selector
    $(document).on('click', '.js-upsell-show-options', (e) => {
        const button = e.target;
        const parent = button.closest('.upsell-quick-add');
        const optionContainer = parent.querySelector('.js-upsell-options');
        button.classList.add('hide');
        optionContainer.classList.remove('hide');
        
        const optionSelect = optionContainer.querySelector('select');
        const isPromo = optionSelect.getAttribute('data-promo');
        const tier = optionSelect.getAttribute('data-tier');
    
        optionSelect.addEventListener('change', (e) => {
            e.target.classList.add('btn--loading');
            const variantId = e.target.value;
            const qty = e.target.options[event.target.selectedIndex].dataset.min || 1;
            if(isPromo && tier) {
                const props = {
                    '_promo-tier': tier
                }
                addProductToCartById(variantId,1,props);
                setTimeout(function() {
                    theme.CartPromoDrawer.close();
                },500);
            } else {
                addProductToCartById(variantId, qty);
            }
        })
    })

    document.addEventListener('cart:ready', (e) => {
        if (theme.settings.enableGiftWithPurchase) {
            checkCartPromo()
        } else {
            $('.drawer-promotion-button').hide();
            $('.promotion-tier').hide();
        }
    })

    $(document).on('click','.drawer-promotion-button .btn', function() {
        theme.CartPromoDrawer.open();
    });

     // start quick add
     document.addEventListener('click', function(event) {
        if (event.target.classList.contains('quick-add_button')) {
            event.target.closest('.quick-add').classList.add('active');
        }

        if (event.target.classList.contains('quick-add_button-add')) {
            var e = event.target.closest('.quick-add_options').querySelector('[name="id"]');
            var variantId = e.options[e.selectedIndex].text;
            var variantMOQ = e.options[e.selectedIndex].dataset.moq;
            var qtyToAdd = variantMOQ;
            var variantQty = e.options[e.selectedIndex].dataset.quantity;     
              
            // var qtyToAdd = parseInt(e.getAttribute('data-qty')) ? parseInt(e.getAttribute('data-qty')) : 1;
            // if (!qtyToAdd || qtyToAdd <= 0) {
            //     qtyToAdd = 1;
            // }
            if(parseInt(qtyToAdd) <= parseInt(variantQty)) {
                addProductToCartById(variantId,qtyToAdd,{},'open');
            }

            event.target.closest('.quick-add').classList.remove('active');
        }

        if (event.target.classList.contains('quick-add_button-close')) {
            event.target.closest('.quick-add').classList.remove('active');
        }
    })

    document.addEventListener('change', function(event) {
        
        if (event.target.classList.contains('variant-select')) {
            var variantsOptions = event.target.closest('.quick-add_options')

            if (variantsOptions) {
                var variantsSelect = variantsOptions.querySelectorAll('.variant-select')
                var variantTitleArr = [];
                
                for (var x = 0; x < variantsSelect.length; x++) {

                    variantTitleArr.push( variantsSelect[x].value );
                }

                var variantTitle = variantTitleArr.join(' / ');

                event.target.closest('.quick-add_options').querySelector('[name="id"]').value = variantTitle;
            }
        }
    })
    // end quick add

     // Click and drag
     function clickAndDrag(selector, scroll_speed = 2, classOnEvent = 'grabbed_elem') {
        const sliders = document.querySelectorAll(selector);
        let isDown = false;
        let startX;
        let scrollLeft;

        sliders.forEach(slider => {
    
            slider.addEventListener('mousedown', (e) => {
                e.preventDefault();
                isDown = true;
                slider.classList.add(classOnEvent);
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove(classOnEvent);
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove(classOnEvent);
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * scroll_speed; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        });
    }
    
    const mouseClickDragEl = document.querySelector('.js-mouse-click-drag');
    if(mouseClickDragEl) {
        clickAndDrag('.js-mouse-click-drag');
    }
});

// START PDP ALSO AVAILABLE IN
theme.GraphQL = {

    config:  {
        storefront_token: '0fc46787b545caa55a9d5f499e64786f',
        request_url: theme.routes.storefrontAPI
    },

    sendRequest: function(request, request_group, output_container) {

        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "also-available") {
                    theme.AlsoAvailableIn.buildOutput(return_response);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.AlsoAvailableIn = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
        image_url_structure: '',
    };

    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.image_url_structure = $container.data('image-url-structure');

        let request_query = `
        {
            products(first: 100, query: "title:`+config.request_query+`*") {
                edges {
                    node {
                        availableForSale
                        title
                        handle
                        images(first: 2) {
                            edges {
                                node {
                                    originalSrc
                                    url(transform: {maxWidth: 100})
                                }
                            }
                        }
                    }
                }
            }
        }
        `;

        try {
            theme.GraphQL.sendRequest(request_query, "also-available");
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }
    }

    function buildOutput(response) {
        let output_html = '';
        let product_arr = response.data.products.edges;
        
        const requestQuery = this.$container.data('request-query') + '*';
        const filteredProducts = product_arr.filter(p => p.node.title.includes(requestQuery));

        if(filteredProducts.length <= 1) {
            return;
        }

        this.$container.show();

        const regex = /\(([^)]+)\)/;

        console.log({requestQuery, filteredProducts})

        // Builds swatches products
        output_html = filteredProducts.map(p => {
        //   const matches = p.node.title.split(' - ').pop();
          const matches = p.node.title;
          return `
            <a class="product-swatch-button${ p.node.handle === config.current_product ? ' aa-swatch--current' : ''}" href="/products/${p.node.handle}"
            //   style="--bgColor: ${matches.toLowerCase()}; --bgImg: url(${p.node.images.edges[0]?.node?.url});" title="${matches.replace(config.request_query, '').replace('*', '')}">
            </a>
          `;
        }).join('');

        // Select current swatch and displays colour name
        const currentSwatch = filteredProducts.find(p => p.node.handle === config.current_product);
        if (currentSwatch) {
          let matches = regex.exec(currentSwatch.node.title);
          this.$container.find('#current-product-color').append(matches);
        }

        this.$container.find('.aa-container').append(output_html);
        document.dispatchEvent(new CustomEvent('swatchColors:loaded'));

        // Show view more button if required
        if (this.$container.find('.aa-container').height() > 100) {
            this.$container.find('.toggle-pdp-aai-view').css('display', 'inline-block');
        }
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

$(document).ready(function() {
    $('[data-section-type="also-available"]').each(function() {
        theme.AlsoAvailableIn.init(this);
    });
});

$(document).on('mouseenter', '.product-swatch-button', (e) => {
    let wrapper = e.target.closest('.aa-wrapper');
    let label_current = wrapper.querySelector('.current-colour');

    let title = e.currentTarget.getAttribute('title');

    if (label_current && title) {
        label_current.innerHTML = title;
    }
})

$(document).on('mouseleave', '.product-swatch-button', (e) => {
    let wrapper = e.target.closest('.aa-wrapper');
    let label_current = wrapper?.querySelector('.current-colour');

    let title = wrapper.querySelector('.product-swatch-button.aa-swatch--current')?.getAttribute('title');

    if (label_current && title) {
        label_current.innerHTML = title;
    }
})
// END PDP ALSO AVAILABLE IN

// START PDP AAI TOGGLE
$(document).on('click', '.toggle-pdp-aai-view', (e) => {
    const button = e.currentTarget;
    const parent = button.closest('.aa-wrapper');
    const panel = parent?.querySelector('.aa-container');

    if (!parent || !panel) return;

    if (button.getAttribute('data-active') == 'false') {
        panel.classList.add('expanded');
        button.setAttribute('data-active', 'true');
        button.innerHTML = 'Show Less';
    } else {
        panel.classList.remove('expanded');
        button.setAttribute('data-active', 'false');
        button.innerHTML = 'Show More';
    }
    
})
// END PDP AAI TOGGLE

// PLP Related articles
class RelatedArticles extends HTMLElement {
    constructor(){
        super();

        this.collection = this.dataset.collection;
        this.blogs = this.dataset.blogs;
        this.token = '1c22ee4edbdc507a1adc6da9f8bd16f6';
        this.endpoint = theme.routes.storefrontAPI;
        this.data = [];
        this.parent = this.closest('.tabbed-blogs');
        this.viewAll = this.dataset.viewAll;
        this.hasBgImg = this.dataset.hasBgImg;
        this.sliderArr = [];

        if(this.collection && this.blogs) {
            this.runQuery();
        }
    }

    async runQuery() {
        this.blogs = this.blogs.split(',');
        for(let i=0; i<this.blogs.length; i++) {
            try {
                const res = await fetch(this.endpoint, {
                    method: 'POST',
                    headers: {
                        'X-Shopify-Storefront-Access-Token': this.token,
                        'Content-Type': 'application/graphql',
                    },
                    body: `{
                        blogByHandle(handle: "${this.blogs[i]}") {
                            articles(query: "tag:_plp_${this.collection}", first: 250) {
                                edges {
                                    node {
                                        image {
                                            altText
                                            transformedSrc(maxWidth: 400)
                                        }
                                        onlineStoreUrl
                                        publishedAt
                                        tags
                                        title
                                    }
                                }
                            }
                            id
                            onlineStoreUrl
                            title
                        }
                    }`
                });
                const data = await res.json();
                if (res.ok) {
                    this.data.push(data.data.blogByHandle);
                    if(i === this.blogs.length - 1) {
                        this.renderElements();
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    renderElements() {
        let showSection = false;
        let tabBtnsHtml = '';
        let innerContentHtml = '';
        let count = 0;
        this.data.forEach(blog => {
            const articles = blog.articles.edges;
            articles.sort((a, b) => new Date(b.node.publishedAt) - new Date(a.node.publishedAt));

            if(articles.length > 0) {
                count++;
                showSection = true;
                tabBtnsHtml += `
                    <button data-blog-id="${blog.id}" data-blog-title="${blog.title}" data-blog-url="${blog.onlineStoreUrl}" type="button" class="tabbed-blogs__tab tabbed-blogs__tab-btn${count === 1 ? ' active' : ''}${this.hasBgImg === "true" ? ' tabbed-blogs__tab-btn--outline' : ''}">${blog.title}</button>
                `;
                innerContentHtml += `
                    <div data-blog-id="${blog.id}" class="tabbed-blogs__blog-wrapper${count === 1 ? ' active' : ''}">
                        <div data-flickity='{ "cellAlign": "left", "contain": true }' class="tabbed-blogs__blog grid grid--uniform">
                `;
                articles.forEach(article => {
                    let tagsHtml = '';
                    let tagsInnerHtml = '';
                    let tagCount = 0;
                    const date_options =  { month: 'short', year: '2-digit', };
                    const date = new Date(article.node.publishedAt);
                    const formattedDate = date.toLocaleDateString("en-US", date_options);
                    article.node.tags.forEach(tag => {
                        if(!tag.startsWith('_')) { 
                            if(tagCount < 3) {
                                let tagHandle = tag.replaceAll(' ', '-');
                                tagHandle = tagHandle.replaceAll('&-', '');
                                tagsInnerHtml += `<a href="${blog.onlineStoreUrl}/tagged/${tagHandle}"> ${tag} </a>`;
                            }
                            tagCount++;
                        }
                    })
                    if(tagCount > 0) {
                        tagsHtml = `<div class="article__tags">${tagsInnerHtml}</div>`;
                    }
                    innerContentHtml += `
                        <div class="grid__item medium-up--30p small--50p" data-aos="row-of-4">
                            <div class="grid-article-wrapper">
                                <a href="${article.node.onlineStoreUrl}" class="article__grid-image" aria-label="${article.node.title}">
                                    <div class="image-wrap loaded">
                                        <div class="grid__image-ratio grid__image-ratio--landscape">
                                            <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
                                                <img src="${article.node.image.transformedSrc}" alt="${article.node.title}" loading="lazy" class=" image-element" sizes="33vw"> 
                                            </image-element>
                                        </div>
                                    </div>
                                </a>
                                <div class="article__grid-meta text-center">
                                    ${tagsHtml}
                                    <a href="${article.node.onlineStoreUrl}" class="article__title">${article.node.title}</a>
                                    <div class="article__date">${formattedDate}</div>
                                    <a href="${article.node.onlineStoreUrl}" class="article-read-more">Read More</a>
                                </div>
                            </div>
                        </div>
                    `;
                });
                innerContentHtml += `</div>`;
                if(this.viewAll === "true") {
                    innerContentHtml += `
                        <div class="page-width">
                            <div class="text-center" style="margin-top: 55px;">
                                <a class="btn shop-all-link" href="${blog.onlineStoreUrl}">View All ${blog.title}</a>
                            </div>
                        </div>
                    `;
                }
                innerContentHtml += `</div>`;
            }
        })

        if(showSection) {
            this.parent.classList.remove('hide');

            let tabsHtml = `
                <div class="page-width">
                    <div class="tabbed-blogs__tabs">
                        ${tabBtnsHtml}
                    </div>
                </div>
            `;

            let innerTabsHtml = `
                <div class="page-width--left">
                    <div class="tabbed-blogs__blogs">
                        ${innerContentHtml}
                    </div>
                </div>
            `;

            this.innerHTML = tabsHtml + innerTabsHtml;
            this.initSliders();
            this.initTabs();
        }
    }

    initSliders() {
        const sliders = this.querySelectorAll('.tabbed-blogs__blog');
        if(sliders.length) {
            sliders.forEach(slide => {
                let flkty = new Flickity( slide, {
                  // options
                  cellAlign: 'left',
                  contain: true
                });
          
                this.sliderArr.push(flkty);
            });
        }
    }

    initTabs() {
        const tabBtns = this.querySelectorAll('.tabbed-blogs__tab-btn');
        if(tabBtns.length) {
            tabBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    this.revealTab(e);
                })
            })
        }
    }

    revealTab(e) {
        const tab = e.currentTarget;
        const tabs = this.querySelectorAll('.tabbed-blogs__tab');
        const blogs = this.querySelectorAll('.tabbed-blogs__blog-wrapper');
        const targetblogID = tab.getAttribute('data-blog-id');

        // remove all active classes
        tabs.forEach(tab => {
            tab.classList.remove('active');
        })
        blogs.forEach(tab => {
            tab.classList.remove('active');
        })

        // add active class
        tab.classList.add('active');
        blogs.forEach(blog => {
            if (blog.getAttribute('data-blog-id') == targetblogID) {
                blog.classList.add('active');

                this.sliderArr.forEach(slider => {
                    slider.reloadCells()
                    slider.resize()
                })
            }
        })
    }
}
customElements.define('related-articles', RelatedArticles);

// Custom Market Selector
window.addEventListener('DOMContentLoaded', () => {
    $(document).on('click', '.market-selector-link', (e) => {
        const actualButton = document.querySelector('md-footer-selector__form .md-footer-selector__selector');
        if (actualButton) {
            actualButton.click();
        }
    })
})

document.addEventListener('rebuy:cart.add', () => {
    document.dispatchEvent(new CustomEvent('cart:build'));
});